import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("autexio_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Only clear on explicit auth failures.
      const isAuthEndpoint = err.config?.url?.includes("/auth/");
      if (!isAuthEndpoint) {
        localStorage.removeItem("autexio_token");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Errore";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  }
  // Structured errors: `{code, message, retry_after?}` (e.g. email_not_verified,
  // rate_limited). Surface the human message for toasts / inline errors.
  if (typeof detail === "object" && detail.message) return detail.message;
  return String(detail);
}

export function apiErrorCode(err) {
  const detail = err?.response?.data?.detail;
  return (detail && typeof detail === "object" && detail.code) || null;
}
